// Flattens a DRF error value (string | array | nested object) into a readable string.
function flattenError(value) {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) {
    return value.map(flattenError).filter(Boolean).join(' ');
  }
  if (typeof value === 'object') {
    return Object.values(value).map(flattenError).filter(Boolean).join(' ');
  }
  return String(value);
}

// Maps the validation response `triggers` map into per-row field errors.
//
// The backend returns 200 `{ valid, triggers }`, where `triggers` is keyed by the
// sent row index and each value is either:
//   - a string         → row-level slot error (duplicate / cross-template),
//   - { send_condition / non_field_errors: [...] } → field/row errors.
// Day range is enforced client-side (sanitizeDayInput clamps to 1–30), so the
// backend `day` field error can no longer occur and is not surfaced.
//
// `rowIndices[sentIndex]` maps a sent position back to the original form row index.
export function parseTriggerValidationRowErrors(triggersByIndex, rowIndices = []) {
  const rowErrors = {};
  if (!triggersByIndex || typeof triggersByIndex !== 'object') return { rowErrors };

  Object.entries(triggersByIndex).forEach(([sentKey, entry]) => {
    const sentIndex = Number(sentKey);
    const formIndex = Number.isInteger(sentIndex) ? (rowIndices[sentIndex] ?? sentIndex) : sentKey;

    if (typeof entry === 'string') {
      rowErrors[formIndex] = { nonField: entry };
      return;
    }
    if (entry && typeof entry === 'object' && !Array.isArray(entry)) {
      const sendCondition = flattenError(entry.send_condition);
      const nonField = flattenError(entry.non_field_errors);
      if (sendCondition || nonField) rowErrors[formIndex] = { sendCondition, nonField };
      return;
    }
    const message = flattenError(entry);
    if (message) rowErrors[formIndex] = { nonField: message };
  });

  return { rowErrors };
}
